(function () {
  if (window.__cartStickyOffsetBound === true) return;
  window.__cartStickyOffsetBound = true;

  var setOffset = function () {
    var header = document.querySelector('.header-main-wrapper');
    var height = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--cart-sticky-header-offset', height + 'px');
  };

  setOffset();
  window.addEventListener('resize', setOffset);
  window.addEventListener('load', setOffset);

  var header = document.querySelector('.header-main-wrapper');
  if (header != null && typeof window.ResizeObserver === 'function') {
    new ResizeObserver(setOffset).observe(header);
  }
})();
